import React from "react"

const BackgroundSquare = () => {
  return (
    <div className="lg:block xl:block max-w-[550px] max-h-[550px] -translate-x-1/4 -mt-48 md:-mt-48 lg:-mt-48 lg:h-[550px] lg:w-[550px] rotate-hero z-[-1] absolute bg-slate-100 rounded-3xl bg-brushinvisible md:visible" />
  )
}

export default BackgroundSquare
